import React from "react";

// Adjudicator account state (card 930d3ac0): every adjudicator gets their own
// Feis.link account. The API sends accountStatus on organiser/admin lists:
// "active" (has an account), "invited" (emailed, not accepted yet), "email"
// (email saved, invited when next booked) or "none". Colours are DESIGN.md
// tokens: {colors.primary}, {colors.warning-*}, {colors.ink-subtle}.
const LOOK = {
  active: { label: "Account set up", color: "#68ad3f", background: "#ffffff", border: "#68ad3f" },
  invited: { label: "Invited", color: "#6d4c00", background: "#fff8e1", border: "#ffe082" },
  email: { label: "Not invited yet", color: "#797979", background: "#ffffff", border: "#dcdcdc" },
  none: { label: "No email", color: "#797979", background: "#ffffff", border: "#dcdcdc" },
};

// Status from an admin Collaborators row (raw email / invite / user_id) or
// from accountStatus sent by the API.
export const adjudicatorStatusOf = (person) => {
  if (!person) return "none";
  if (person.accountStatus) return person.accountStatus;
  if (person.user_id) return "active";
  if (person.invite && person.invite.status === "invited") return "invited";
  if (person.email) return "email";
  return "none";
};

const AdjudicatorStatus = ({ status, detail }) => {
  const look = LOOK[status] || LOOK.none;
  return (
    <span
      title={detail || look.label}
      style={{
        display: "inline-block",
        fontSize: "11px",
        fontWeight: 500,
        lineHeight: "16px",
        padding: "1px 8px",
        borderRadius: "4px",
        border: `1px solid ${look.border}`,
        background: look.background,
        color: look.color,
        whiteSpace: "nowrap",
      }}
    >
      {look.label}
    </span>
  );
};

export default AdjudicatorStatus;
